export const tableConstants = {
  DIRECTION_REPLACE: 'DIRECTION_REPLACE',
  DIRECTION_AFTER: 'DIRECTION_AFTER',
  DIRECTION_BEFORE: 'DIRECTION_BEFORE',
};
